import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { TitleProps } from "./TitleProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'TitleComponent',
  props: {
    text: {},
    tag: {},
    textColor: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
    class: "text-4xl xl:text-7xl font-semibold tracking-tight text-balance",
    style: _normalizeStyle({ color: _ctx.textColor })
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.text), 1)
    ]),
    _: 1
  }, 8, ["style"]))
}
}

})